import Overlay from '@/libs/cifra/overlay';
import { waitForTurboFormSubmissionResult } from '@/libs/http';
import ApplicationController from './application_controller';

// Marcamos un formulario con la clase form-overlay y entonces ponemos
// el overlay cuando hacen el submit
export default class extends ApplicationController {
  connect() {
    this.element.addEventListener('submit', (_event) => {
      const overlay = new Overlay(this.#getOverlayTarget());
      overlay.show();

      if (this.element.dataset.turbo !== false) {
        waitForTurboFormSubmissionResult(this.element).finally(() => {
          overlay.hide();
        });
      }
    });
  }

  #getOverlayTarget() {
    if (!this.element.dataset.overlayTarget) {
      return this.element;
    }

    return document.querySelector(this.element.dataset.overlayTarget);
  }
}
